import React from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Button, Box } from "@mui/material";

export default function ConfirmDialog({ open, title = "Confirm", description, confirmText = "Confirm", cancelText = "Cancel", onConfirm, onCancel }) {
    return (
        <Dialog open={open} onClose={onCancel} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description">
            <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <Typography>{description}</Typography>
            </DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
                <Button onClick={onCancel} sx={{ mr: 2 }}>{cancelText}</Button>
                <Button onClick={onConfirm} color="error" variant="contained">{confirmText}</Button>
            </Box>
        </Dialog>
    );
}
